import React from 'react';
import { fieldsWidgetStyles } from './FieldsWidget.styles';
import { withStyles, Button } from '@material-ui/core';
import { IFieldButtonProps, IHyperLinkComponentProps, IValueComponentProps } from './FieldsWidget.properties';
import { Colours } from './FieldsWidget.constants';
import { generateAnchorProps, urlConstructor } from './FieldsWidget.utils';
import classNames from 'classnames';
import { Fax, Mail, Mobile, Phone, Web } from '@markinson/uicomponents-v2/SvgIcons';

const iconMap = {
  Web: <Web titleAccess='Web' />,
  Fax: <Fax titleAccess='Fax' />,
  Phone: <Phone titleAccess='Phone' />,
  Mobile: <Mobile titleAccess='Mobile' />,
  Email: <Mail titleAccess='Mail' />,
};

const IconRenderer = ({ type }) => (iconMap[type] || `${type?.[0]}:`);

const HyperLink = ({ classes, type, value }: IHyperLinkComponentProps) => {
    return (
        <span className={classes.hrefContainer}>
            <span>
                <IconRenderer type={type} />
            </span>
            <span className={classes.hrefValue}>
                <a {...generateAnchorProps(type, value)} className={classes.hrefValue}>
                    {value}
                </a>
            </span>
        </span>
    );
};

const FieldButton = ({ classes, onClickHandler, isClickable, label }: IFieldButtonProps) => {
    return (
        <Button
            onClick={onClickHandler}
            className={classNames(classes.FieldButton, isClickable ? classes.actionBtn : classes.labelBtn)}
        >
            {label || 'Button'}
        </Button>
    );
};

export const FieldValue = ({ classes, value, alignment, color }: IValueComponentProps) => {
    return (
        <span
            className={color ? classes.valueComponentColor : classes.valueComponent}
            style={{
                ...((color) ? ({
                    backgroundColor: Colours[color],
                }) : ({ textAlign: (alignment as any), }))
            }}>
            {value}
        </span>
    );
};

export const RenderFieldValue = ({ obj, props }) => {
    if (obj?.type === 'Button') return <ButtonComponent isClickable={!!obj.link} label={obj.label || 'Button'} onClickHandler={() => window.open(urlConstructor(obj.link, props))} />;
    if (obj?.type === 'FieldData') return <ValueComponent color={obj?.color} alignment={obj?.alignment} value={obj.value} />;

    return <HyperLinkComponent type={obj?.type} value={obj.value} />;
};

export const ValueComponent = withStyles(fieldsWidgetStyles)(FieldValue);
export const ButtonComponent = withStyles(fieldsWidgetStyles)(FieldButton);
export const HyperLinkComponent = withStyles(fieldsWidgetStyles)(HyperLink);
